import React, { useState } from 'react'
import { Col, Row, Form, Badge } from 'react-bootstrap';
import styles from './emailDetails.module.scss';
import { Formik } from 'formik';
import * as yup from 'yup';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomButton } from '../../../../shared/customButton';

function EmailDetails(props) {

    let [html_value, set_html_value] = useState(props.emailData.templateBody);
    let contentState = '';

    if (html_value) {
        const blocksFromHtml = htmlToDraft(html_value && html_value);
        const { contentBlocks, entityMap } = blocksFromHtml;
        contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    }

    const [editorState, setEditorState] = useState(
        html_value ?
            EditorState.createWithContent(contentState)
            :
            () => EditorState.createEmpty()
    );

    //yup validations
    const schema = yup.object({
        emailSubject: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').required('Required').nullable(),
        emailBody: yup.string().max(4000, 'Content is too lengthy').test('email body check', 'Required', function (item) {
            if (item) {
                let stripedHtml = item.replace(/<[^>]+>/g, '');
                if ((stripedHtml).length > 1) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        }).nullable(),
    });

    return (
        <div>
            <Row>
                <Col>
                    <p className={styles.stepSubtopicName}>Email Template Configurations</p>
                </Col>
            </Row>
            <hr className={styles.subTopicDivider} />
            <div className='mt-4'>
                <Formik
                    validationSchema={schema}
                    enableReinitialize
                    onSubmit={(values) => props.onSubmitEmailData(values)}
                    initialValues={{ emailSubject: props.emailData.email_subject, emailBody: props.emailData.templateBody }}>

                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        errors,
                        submitCount
                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Label className={styles.defaultLabel}> To </Form.Label>
                            {(props.candidateEmail).length !== 0 &&

                                <Row className="ml-0 mr-0">
                                    {
                                        (props.candidateEmail).map((item, i) => (
                                            (
                                                <div className={styles.emailbadgeDiv} key={i}>
                                                    <Badge variant="primary" className={styles.emailbadge}>{item}&nbsp;&nbsp;

                                                    </Badge>
                                                </div>
                                            )
                                        ))
                                    }
                                </Row>
                            }

                            <CustomTextField
                                label="Email Subject"
                                classLabel="defaultLabel"
                                controlId="emailSubject"
                                type="text"
                                handleOnChange={handleChange}
                                name="emailSubject"
                                classType="defaultTextBox"
                                value={values.emailSubject}
                                errorMessage={errors.emailSubject}
                                isInvalid={submitCount > 0 && errors.emailSubject}
                            />
                            <Form.Group>
                                <Form.Label className={styles.defaultLabel}>
                                    Email Body Content
                                </Form.Label>

                                <div className={submitCount > 0 && errors.emailBody ? styles.emailBodyContainerError : styles.emailBodyContainer}>
                                    <Editor
                                        toolbar={{
                                            options: ['history', 'inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link'],
                                            inline: {
                                                inDropdown: false,
                                                options: ["bold", "italic", "underline"],
                                            },
                                            list: { inDropdown: true },
                                            textAlign: { inDropdown: true },
                                            link: { inDropdown: true },
                                            history: { inDropdown: true },
                                        }}
                                        editorState={editorState}
                                        onEditorStateChange={setEditorState}
                                        onChange={(e) => { setFieldValue('emailBody', draftToHtml(e)) }}
                                    />
                                </div>
                                {submitCount > 0 && errors.emailBody &&
                                    <div>
                                        <span className={styles.errorMessage}>
                                            {errors.emailBody}
                                        </span>
                                    </div>
                                }
                            </Form.Group>

                            <Col>
                                <Row className={styles.actionBtns}>
                                    <Col className="pl-0">
                                        {<CustomButton
                                            buttonType="button"
                                            label="Cancel"
                                            type="defaultBtn"
                                            handleClick={() => props.closeModal()}

                                        />}
                                    </Col>
                                    <Col className="pr-0">
                                        {<CustomButton
                                            buttonType="submit"
                                            label="Next"
                                            type="primaryBtn"
                                        />}
                                    </Col>
                                </Row>
                            </Col>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    )
}

export default EmailDetails;
